// Vaga-lume do jardim, à noite: um ponto 3×3 de luz amarelada. O halo em volta é pré-desenhado
// (brilho, em ceu-desenho.ts) e piscado pela alfa em campus.ts; o pixel fica no centro.

import { sprite } from './pix.js';
import type { PixelSprite } from './types.js';

export const VAGALUME: PixelSprite = sprite(['.l.', 'lLl', '.l.'], { l: 'light2', L: 'light3' });

/** Cor do halo do vaga-lume (o amarelo do pixel, mais suave). */
export const VAGALUME_COR = 'rgba(255, 216, 110, 1)';
